import React from 'react'
import styled from 'styled-components'
import withLocation from 'src/hoc/withLocation'
import { useTranslation } from 'react-i18next'

import FooterLogo from 'src/assets/images/vectors/footer-logo.svg'
import GlobeIcon from 'src/assets/images/vectors/globe-icon.svg'

export const Footer = props => {
  const { t } = useTranslation()

  return (
      <FooterWrapper>
        <FooterContent>
          <div className='footer__logo'>
            <img
              src={FooterLogo}
              className='footer__logo-image'
              alt='panda-heart'
            />
          </div>
          <div className='footer__content'>
            <div className='system-owner'>
              {t('footer.systemOwner')}
            </div>
            <div className='company-description'>
              We are a professional WordPress, WooCommerce and Digital transformation company based in Poland. We help our nearshore and overseas partners grow their businesses and revenue.
            </div>
            <div className='find-more'>
              <div>{t('footer.findMore')}</div>
              <div><img src={GlobeIcon} alt='globe-icon' /><a href='https://www.whitelabelcoders.com'>whitelabelcoders.com</a></div>
            </div>
            <div className='legal'>{t('footer.copyright', { currentYear: new Date().getFullYear() })}</div>
          </div>
        </FooterContent>
      </FooterWrapper>
  )
}

export default withLocation(Footer)

const FooterWrapper = styled.div`
  position: relative;
  background-color: ${props => props.theme.palette.primary.dark};
  padding: 160px 0 50px 0;
  z-index: 3;
`

const FooterContent = styled.div`
  box-sizing: border-box;

  .footer__logo {
    position: absolute;
    top: 30px;
    left: calc(50vw - 157px);
  }

  .footer__content {
    font-size: 16px;
    font-weight: 500;
    color: ${props => props.theme.palette.common.white};
    max-width: 844px;
    padding: 0 20px;
    margin: 0 auto;
    text-align: center;

    .company-description {
      margin-top: 32px;
    }

    .legal {
      margin-top: 96px;
      font-weight: 400;
      font-size: 14px;
    }

    .find-more {

      div {
        margin-top: 32px;
      }

      div:nth-child(2) {
        display: flex;
        align-items: center;
        gap: 8px;
        justify-content: center;
        a {
          color: ${props => props.theme.palette.common.white};
          font-weight: 800;
        }
      }
    }

    ${props => props.theme.breakpointsMedia.desktop} {
      .find-more {
        display: flex;
        justify-content: center;
        gap: 24px;
      }
    }
  }
`
